import {
  CREATE_LICENSE_USER,
  CREATE_LICENSE_USER_SUCCESS,
  CREATE_LICENSE_USER_ERROR,
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTION_BILLINGS,
  GET_SUBSCRIPTION_BILLINGS_SUCCESS,
  GET_SUBSCRIPTION_BILLINGS_ERROR,
  CHECK_SUBSCRIPTION_STATUS,
  CHECK_SUBSCRIPTION_STATUS_SUCCESS,
  CHECK_SUBSCRIPTION_STATUS_ERROR,
  DELETE_SUBSCRIPTION,
  DELETE_SUBSCRIPTION_SUCCESS,
  DELETE_SUBSCRIPTION_ERROR,
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_ERROR,
  MARK_SUBSCRIPTION_PAID,
  MARK_SUBSCRIPTION_PAID_SUCCESS,
  MARK_SUBSCRIPTION_PAID_ERROR,
  FREEZE_UNFREEZE_SUBSCRIPTION,
  FREEZE_UNFREEZE_SUBSCRIPTION_SUCCESS,
  FREEZE_UNFREEZE_SUBSCRIPTION_ERROR,
} from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  licenseUser: null,
  subscriptions: [],
  billings: [],
  subscriptionStatus: null,
  products: [],
  totalSubscriptions: 0,
  totalBillings: 0,
  totalProducts: 0,
  page: 1,
  limit: 10,
  success: null,
};

const licenseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create License User
    case CREATE_LICENSE_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_LICENSE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        licenseUser: action.payload,
        success: "License user created successfully",
      };
    case CREATE_LICENSE_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Subscription
    case CREATE_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "Subscription created successfully",
      };
    case CREATE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Subscriptions
    case GET_SUBSCRIPTIONS:
      return {
        ...state,
        loading: true,
        error: null,
        page: action.payload.page || 1,
        limit: action.payload.limit || 10,
      };
    case GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriptions: action.payload.result.docs || [],
        totalDocs: action.payload.result.pagination.totalDocs,
      };
    case GET_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      
    // Get Subscription Billings
    case GET_SUBSCRIPTION_BILLINGS:
      return {
        ...state,
        loading: true,
        error: null,
        page: action.payload.page || 1,
        limit: action.payload.limit || 10,
      };
    case GET_SUBSCRIPTION_BILLINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        billings: action.payload.result.docs || [],
        totalBillings: action.payload.result.totalDocs || 0,
      };
    case GET_SUBSCRIPTION_BILLINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        hasNextPage: action.payload.result.pagination.hasNextPage,
        hasPrevPage: action.payload.result.pagination.hasPrevPage,
        limit: action.payload.result.pagination.limit,
        nextPage: action.payload.result.pagination.nextPage,
        page: action.payload.result.pagination.page,
        prevPage: action.payload.result.pagination.prevPage,
        totalPages: action.payload.result.pagination.totalPages,
      };
  
    // Check Subscription Status
    case CHECK_SUBSCRIPTION_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CHECK_SUBSCRIPTION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriptionStatus: action.payload,
      };
    case CHECK_SUBSCRIPTION_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete Subscription
    case DELETE_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "Subscription deleted successfully",
      };
    case DELETE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get Products
    case GET_PRODUCTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.result.docs || [],
        totalProducts: action.payload.result.pagination.total || 0,
      };
    case GET_PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Mark Subscription as Paid
    case MARK_SUBSCRIPTION_PAID:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case MARK_SUBSCRIPTION_PAID_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "Subscription marked as paid successfully",
      };
    case MARK_SUBSCRIPTION_PAID_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Freeze/Unfreeze Subscription
    case FREEZE_UNFREEZE_SUBSCRIPTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FREEZE_UNFREEZE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "Subscription freeze/unfreeze operation completed successfully",
      };
    case FREEZE_UNFREEZE_SUBSCRIPTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default licenseReducer;
